import { useApp } from "../context";
import { money, partnerExposure } from "../lib/engine";

export default function PartnerLimit({ id }) {
  const { state, actions, closeModal } = useApp();
  const p = state.partners.find(x => x.id === id);
  if (!p) return null;
  return (
    <>
      <h2>Edit exposure limit</h2>
      <p>{p.name} · {p.id} · current exposure {money(partnerExposure(state, p))}</p>
      <form data-testid="partner-limit-form" noValidate onSubmit={e => actions.updatePartnerLimit(e, p.id)}>
        <label>New limit in INR
          <input name="limit" type="number" min="0" max="10000000" step="1" required
            defaultValue={p.limit} data-testid="partner-limit-input" />
        </label>
        <p className="notice space">
          Simulation only. Lowering a limit below current exposure does not reverse paid advances;
          it blocks new requests and approvals. The change is recorded in the audit history.
        </p>
        <div className="footer">
          <button type="button" data-testid="partner-limit-cancel-btn" onClick={closeModal}>Cancel</button>
          <button type="submit" className="primary" data-testid="partner-limit-save-btn">Save limit</button>
        </div>
      </form>
    </>
  );
}
